<!-- Heading -->
<h2 mat-dialog-title translate>
  Results Legend
</h2>
<!-- Body -->
<mat-dialog-content>
  <table class="table" style="margin-bottom:0px;" fixed-Header rows="legendCodes.length" aria-label="Code Legend Table" tabindex="0">
    <thead>
      <tr tabindex="0" role="rowheader">
        <th style="min-width:70px;padding-left:10px;" translate>Code</th>
        <th translate>Description</th>
        <th translate>Screening</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let code of legendCodes" tabindex="0" role="row">
        <td style="min-width:70px;padding-left:10px;">{{code.Code}}</td>
        <td>{{code.Definition}}</td>
        <td>{{code.ScreeningType}}</td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>
  <div class="flex-footer-right">
    <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>

